import { setTheme } from "theme/default/setTheme";

export const setFontWeight600 = setTheme(({ theme }) => `font-weight: ${theme.fontWeightValues.font_weight_600}`);
